$(".list-menu__item_render").off("click").on("click", function (e) {
  $('.field__input_custom').val('');
  $('.facet-filters__sort').val('manual').change();

  var sort_url = $(".facet-filters__sort").val();
  var coll_url = $(this).attr('data-url');
  var filter_url = coll_url + '?sort_by=' + sort_url;
  console.log(filter_url);
  fetch(filter_url)
    .then((response) => response.text())
    .then((tabData) => {
      var tab_html = $(tabData);
      var tab_items = $(".product-grid-container_render", tab_html);
      $(".product-grid-container_render").replaceWith(tab_items);
    });

  updateURL(coll_url);

});





// function selectedVarint() {
//   console.log("selectedVarint function called");
//   const urlParams = new URLSearchParams(window.location.search);
//   const variantValue = urlParams.get('variant');
//   console.log("Variant Value:", variantValue);
// }

function matchVariant() {
  let updateValue = "";
  $(".product-form__input input[type='radio']:checked").each(function () {
    updateValue += (updateValue ? " / " : "") + $(this).val();
  });

  $(".variant__select-prod option").each(function () {

    var optionValue = $(this).text().trim();

    if (updateValue.toLowerCase() == optionValue.toLowerCase()) {
      var variantId = $(this).val();
      // if(variantId == variantId){
        $(".variant__select-meta option").each(function(data){
          var productMetaId=$(this).val();
          if(variantId == productMetaId){
            var pack_size= $(this).attr("data-pack-size");
            var ryan_boon_name= $(this).attr("data-supplier");
            var data_options= $(this).attr("data-options");

            //  if(pack_size != 'false'){
            //   $(".meta__pack-size").show();
            //   $(".meta__pack-size").text("Pack Size: " + pack_size);
            //  }else{
            //   $(".meta__pack-size").hide();
            //  }

            //  if(ryan_boon_name != 'false'){
            //   $(".meta__suplier").show();
            //   $(".meta__suplier").text("Suplier: " + ryan_boon_name);
            //  }else{
            //   $(".meta__suplier").hide();
            //  }

            //  if(data_options != 'false'){
            //   $(".meta__option").show();
            //   $(".meta__option").text("Options: " + data_options);
            //  }else{
            //   $(".meta__option").hide();
            //  }

            
            // 
            // 

            $("#pack_size").val(pack_size);
            // $("#ryan_boon_name").val(ryan_boon_name);
            // $("#data_option").val(data_options);
          }
          
        })
      // }


      return true;
    }
  });


}

// Event listener for radio button changes
// $(".product-form__input input[type='radio']").change(function () {
//   matchVariant();

// })

matchVariant();




















function updateURL(collectionPath) {
  var state = window.history.state || {};

  let queryString = Object.entries(state)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

  console.log(window.location.origin);


  var newUrl = window.location.origin + collectionPath;

  if (queryString) {
    newUrl += '?' + queryString;

    newUrl = newUrl.replace(/searchParams=/g, '');
  }
  window.history.pushState(state, "", newUrl);
  console.log("New URL:", newUrl);
}




$(document).ready(function () {
  $('.field__input_custom').on('input', function () {
    var filter = $(this).val().toLowerCase();

    $('.grid__item_padding').each(function () {
      var title = $(this).find('.full-unstyled-link').text().toLowerCase(); // Adjust selector for title
      if (title.includes(filter)) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });
});


$(document).ready(function () {
  $('.search__input').on('input', function () {
    var filter = $(this).val().toLowerCase();

    $('.grid__item_padding').each(function () {
      var title = $(this).find('.full-unstyled-link').text().toLowerCase(); // Adjust selector for title
      if (title.includes(filter)) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });
});